// frontend/src/context/Web3Context.jsx
import React, { createContext, useContext } from "react";
import { useWeb3 } from "../hooks/useWeb3";
import { useEntropyOracle } from "../hooks/useEntropyOracle";
import { useEntropyToken } from "../hooks/useEntropyToken";
import { useEntropyNFT } from "../hooks/useEntropyNFT";

const Web3Context = createContext(null);

export function Web3Provider({ children }) {
  const web3 = useWeb3();
  const entropyOracle = useEntropyOracle();
  const entropyToken = useEntropyToken();
  const entropyNFT = useEntropyNFT();

  const value = {
    web3,
    contracts: {
      entropyOracle,
      entropyToken,
      entropyNFT,
    },
  };

  return <Web3Context.Provider value={value}>{children}</Web3Context.Provider>;
}

export function useWeb3Context() {
  const context = useContext(Web3Context);
  if (!context) {
    throw new Error("useWeb3Context must be used within a Web3Provider");
  }
  return context;
}
